/* External dependencies */
import { Epic, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { switchMap, mergeMap, catchError } from 'rxjs/operators';
import { Action } from 'redux';

/* Local dependencies */
import { updateDeviceRequest } from './service';
import {
  UpdateDeviceActionTypes,
  updateDeviceSuccess,
  updateDeviceFailure,
  UpdateDeviceAction,
} from './acrions';
import { UpdateDeviceInput, Device } from '../../types';
import { listDevice } from '../../list-device/redux/actions';
import { RootState } from '../../../../redux/store';

export const updateDeviceEpic: Epic<Action, Action, RootState> = (action$) =>
  action$.pipe(
    ofType(UpdateDeviceActionTypes.UPDATE_DEVICE_REQUEST),
    switchMap((action: UpdateDeviceAction) =>
      from(updateDeviceRequest(action.payload as UpdateDeviceInput)).pipe(
        mergeMap((device: Device) => [updateDeviceSuccess(device), listDevice()]),
        catchError((error) =>
          of(
            updateDeviceFailure(
              error instanceof Error ? error.message : 'Failed to update device',
            ),
          ),
        ),
      ),
    ),
  ); 